export default __webpack_public_path__ + "static/media/Icon-AI-Assistant-FAB.e822b952.svg";